export default __webpack_public_path__ + "fbc32473526ac4a9c312f94f99f27a1d.png";